
import React from "react";
import FeatureBoxes from "@/components/FeatureBoxes";

const CraftLettersSection = () => {
  return (
    <section className="py-16 md:py-24 bg-elfPink-light">
      <div className="container mx-auto px-4">
        <h2 className="section-title mb-12 md:mb-16">
          Craft <span className="text-white">Enchanting Elf Letters</span> With Ease
        </h2>
        
        <div className="relative z-10">
          <FeatureBoxes />
        </div>
      </div>
    </section>
  );
};

export default CraftLettersSection;
